// const candidatesData = [
//   {
//     name: "John Doe",
//     email: "johndoe@example.com",
//     jobTitle: "Software Engineer",
//     phone: "+1 123-456-7890",
//     joiningDate: "2025-02-10T18:30:00.000Z",
//   },
//   {
//     name: "Alice Smith",
//     email: "alice.smith@example.com",
//     jobTitle: "Frontend Developer",
//     phone: "+44 7894-567-890",
//     joiningDate: "2025-03-15T18:30:00.000Z",
//   },
//   {
//     name: "Ravi Kumar",
//     email: "ravi.kumar@example.com",
//     jobTitle: "Backend Developer",
//     phone: "+91 98765-43210",
//     joiningDate: "2025-04-20T18:30:00.000Z",
//   },
//   {
//     name: "Emily Johnson",
//     email: "emily.johnson@example.com",
//     jobTitle: "Full Stack Developer",
//     phone: "+1 345-678-9012",
//     joiningDate: "2025-05-05T18:30:00.000Z",
//   },
// ];

// export default candidatesData;

export const candidatesData = [
  {
    jobCode: "JB-001",
    consultantName: "Ravindra Rao",
    consultantType: "Regular",
    startDate: "2019-02-01T00:00:00.000Z",
    endDate: "2025-02-28T00:00:00.000Z",
  },
  {
    jobCode: "JB-002",
    consultantName: "Satya Venkata Phani Simhadri",
    consultantType: "Consultant",
    startDate: "2022-08-08T00:00:00.000Z",
    endDate: "2025-12-31T00:00:00.000Z",
  },
];

export const lcaData = [
  {
    lcaNumber: "I-200-23541-785484",
    location: "Treton, New Jersey",
    prevailingWage: "$154875",
    startDate: "2025-08-31T00:00:00.000Z",
    endDate: "2025-02-12T00:00:00.000Z",
    status: "Active",
    documents: "2",
    paf: "--",
  },
];
export const honeBData = [
  {
    employeeName: "Ramesh Manthri",
    honeBType: "Extension",
    filedOn: "2025-08-10T00:00:00.000Z",
    receiptNumber: "EAC2014951144",
    status: "Expired",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "0",
    actions: "",
  },
];
export const visaData = [
  {
    visaType: "Regular",
    issueDate: "2025-08-01T00:00:00.000Z",
    expirationDate: "2025-08-10T00:00:00.000Z",
    petitionEndDate: "2025-08-31T00:00:00.000Z",
    visaStatus: "Active",
    documents: "0",
    status: "Active",
    actions: "",
  },
];
export const greenCardData = [
  {
    employeeName: "Ramesh Manthri",
    employeeType: "Employee",
    status: "Active",
    appliedOn: "2025-08-31T00:00:00.000Z",
    comments: "--",
    documents: "2",
  },
];

//document table data
export const documentTableData = [
  {
    documentType: "I-9",
    title: "1-9",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "2",
  },
  {
    documentType: "Passport",
    title: "Passport",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "0",
  },
  {
    documentType: "MSA",
    title: "SubAgr (NJ V1.1 15) Tektree LLC",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "2",
  },
  {
    documentType: "W4",
    title: "W4",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "2",
  },
  {
    documentType: "Voided Check",
    title: "Voided Check",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "2",
  },
  {
    documentType: "Employment Agreement",
    title: "Sukumar Employment Agreement",
    status: "Active",
    expiryDate: "2025-08-31T00:00:00.000Z",
    documents: "2",
  },
];

export const activityTableData = [
  {
    dateAndTime: "2025-02-18T11:15:05.000Z",
    record: "Sukumar Mididodi - 2025-01-01 to 2025-01-31",
    description: "Approved with 184:00 Hours by vikranth.d@tektreeinc.com",
    updatedBy: "Vikranth Desireddy",
  },
  {
    dateAndTime: "2025-02-18T11:04:22.000Z",
    record: "Sukumar Mididodi - 2025-01-01 to 2025-01-31",
    description: "Approved with 184:00 Hours by hemalatha@tektreeinc.com",
    updatedBy: "Hemalatha Medishetti",
  },
  {
    dateAndTime: "2025-02-18T20:28:49.000Z",
    record: "Sukumar Mididodi - 2025-01-01 to 2025-01-31",
    description:
      "Timesheet has been submitted with 184:00 Hours by Sukumar Mididodi",
    updatedBy: "Sukumar Mididodi",
  },
];
//clientDocument Table data dummy
export const clientDocumentTableData = [
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Software EngineerIII_Seaglass",
    jobCode: "CAI-001",
    documentType: "MSA",
    title: "MSA",
    documentComments: "--",
    expiryDate: "--",
    status: "Active",
    documents: "0",
  },
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Technical Consultant_Computer Aid Inc",
    jobCode: "CAI-001",
    documentType: "WO",
    title: "WO",
    documentComments: "--",
    expiryDate: "--",
    status: "Active",
    documents: "0",
  },
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Siebel Lead Developer",
    jobCode: "CAI-001",
    documentType: "SOW",
    title: "WO",
    documentComments: "--",
    expiryDate: "2024-04-30T11:04:22.000Z",
    status: "Active",
    documents: "0",
  },
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Software Engineer III_Seaglass",
    jobCode: "CAI-001",
    documentType: "WO",
    title: "PO",
    documentComments: "--",
    expiryDate: "2025-06-03T11:04:22.000Z",
    status: "Active",
    documents: "0",
  },
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Siebel Lead Developer",
    jobCode: "CAI-001",
    documentType: "SOW",
    title: "PO",
    documentComments: "--",
    expiryDate: "--",
    status: "Active",
    documents: "0",
  },
  {
    consultantName: "--",
    consultantCode: "EMP - 1049",
    placement: "Siebel Lead Developer",
    jobCode: "CAI-001",
    documentType: "WO",
    title: "WO",
    documentComments: "--",
    expiryDate: "2024-09-30T11:04:22.000Z",
    status: "Active",
    documents: "0",
  },
];

//invoices table data
export const invoicesTableData = [
  {
    invoiceNumber: "16444",
    employee: "Ramesh Manthri",
    client: "Shubha Minds, LLC",
    clientCode: "CLN-250",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "9600.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "9600.00 USD",
    homeCurrency: "9600.00 USD",
  },
  {
    invoiceNumber: "16436",
    employee: "Ramesh Manthri",
    client: "Computer Aid Inc",
    clientCode: "CLN-206",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "19600.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "19600.00 USD",
    homeCurrency: "19600.00 USD",
  },
  {
    invoiceNumber: "16435",
    employee: "Ramesh Manthri",
    client: "Shubha Minds, LLC",
    clientCode: "CLN-250",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "8452.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "8452.00 USD",
    homeCurrency: "8452.00 USD",
  },
  {
    invoiceNumber: "16434",
    employee: "Ramesh Manthri",
    client: "Computer Aid Inc",
    clientCode: "CLN-206",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "42512.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "42512.00 USD",
    homeCurrency: "42512.00 USD",
  },
  {
    invoiceNumber: "16433",
    employee: "Ramesh Manthri",
    client: "Shubha Minds, LLC",
    clientCode: "CLN-250",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "9600.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "9600.00 USD",
    homeCurrency: "9600.00 USD",
  },
  {
    invoiceNumber: "16432",
    employee: "Ramesh Manthri",
    client: "Computer Aid Inc",
    clientCode: "CLN-206",
    invoiceDate: "2025-01-31T00:00:00.000Z",
    shippedDate: "2025-02-17T00:00:00.000Z",
    invoiceDueDate: "2025-04-20T00:00:00.000Z",
    invoicedAmount: "9600.00 USD",
    receivedAmount: "0.00 USD",
    dueAmount: "9600.00 USD",
    homeCurrency: "9600.00 USD",
  },
];

//invoices ReceivePayment Table Data
export const invoicesReceivePaymentTableData = [
  {
    id: 1,
    invoiceNumber: "16444",
    activity: "03/01/2025-03/31/2025",
    subcustomer: "--",
    invoiceDate: "2025-04-04T00:00:00.000Z",
    dueDate: "2025-05-19T00:00:00.000Z",
    invoiceAmount: "12768.00",
    paymentReceived: "12768.00 USD",
    balance: "12768.00 USD",
    enterPaymentAmount: "12768",
    paymentDiscount: "0.00 USD",
  },
  {
    id: 2,
    invoiceNumber: "16436",
    activity: "03/01/2025-03/31/2025",
    subcustomer: "--",
    invoiceDate: "2025-04-04T00:00:00.000Z",
    dueDate: "2025-05-19T00:00:00.000Z",
    invoiceAmount: "12768.00",
    paymentReceived: "12768.00 USD",
    balance: "12768.00 USD",
    enterPaymentAmount: "12768",
    paymentDiscount: "0.00 USD",
  },
  {
    id: 3,
    invoiceNumber: "16435",
    activity: "03/01/2025-03/31/2025",
    subcustomer: "--",
    invoiceDate: "2025-04-04T00:00:00.000Z",
    dueDate: "2025-05-19T00:00:00.000Z",
    invoiceAmount: "12768.00",
    paymentReceived: "0.00 USD",
    balance: "12768.00 USD",
    enterPaymentAmount: "12768",
    paymentDiscount: "0.00 USD",
  },
];

//invoice Details table inside employee invoice details
export const invoicesDetailsTableData = [
  {
    serviceSummary: "Ramesh Manthri",
    activity: "",
    accountType: "Citizen Bank Checking",
    attachment: "--",
    "quantity(Hrs/Days)": "160",
    rate: "60.00",
    amount: "9600.00 USD",
  },
];

export const avaitingAprrovalTableData = [
  {
    month: "2020-04-20T00:00:00.000Z",
    totalHours: "24",
    missingDates: "",
  },
];
export const invoicesDetailsActivityTableData = [
  {
    dateAndTime: "2025-03-14T03:52:36.000Z",
    description: "Invoiced 16444 Synced to QB",
    updatedBy: "Vikranth Reddy",
  },
  {
    dateAndTime: "2025-03-14T03:52:36.000Z",
    description:
      "Created and Mailed by Vikranth.d@tektreeinc.com for 9600.00USD View Invoice",
    updatedBy: "CLN-206",
  },
];

//timesheetTable data
export const timesheetTableData = [
  {
    endClient: "ShubaMinds, LLC",
    jobTitle: "Siebel Lead Developer",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "184:00",
    TotalBillableHrs: "184:00",
    status: "Active",
    source: "Regular",
  },
  {
    endClient: "ShubaMinds, LLC",
    jobTitle: "Software Engineer III_Seaglass",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "168:00",
    TotalBillableHrs: "168:00",
    status: "Active",
    source: "Regular",
  },
  {
    endClient: "Seaglass Technology Partners",
    jobTitle: "Siebel Lead Developer",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "176:00",
    TotalBillableHrs: "176:00",
    status: "Active",
    source: "Regular",
  },
  {
    endClient: "Computer Aid Inc",
    jobTitle: "Software Engineer III_Seaglass",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "184:00",
    TotalBillableHrs: "184:00",
    status: "Active",
    source: "Regular",
  },
  {
    endClient: "ShubaMinds, LLC",
    jobTitle: "Siebel Lead Developer",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "184:00",
    TotalBillableHrs: "184:00",
    status: "Active",
    source: "Regular",
  },
  {
    endClient: "Computer Aid Inc",
    jobTitle: "Software Engineer III_Seaglass",
    from: "2025-01-01T00:00:00.000Z",
    to: "2025-01-31T00:00:00.000Z",
    attachment: "",
    submittedOn: "2025-02-17T00:00:00.000Z",
    totalHrs: "",
    TotalBillableHrs: "",
    status: "Active",
    source: "Regular",
  },
];

export const placementData = [
  {
    jobCode: "shu-001 Manthri",
    placementCode: "--",
    jobTitle: "Lead Developer",
    billableClient: "ShubhaMinds, LLC",
    projectTitle: "--",
    jobStatus: "Active",
    startDate: "2023-09-08T00:00:00.000Z",
    endDate: "2025-05-10T00:00:00.000Z",
    projectedEndDate: "2024-12-14T00:00:00.000Z",
    payRate: "40.80",
    billRate: "60.00",
    paymentEffectiveDate: "2025-10-05T00:00:00.000Z",
  },
  {
    jobCode: "shu-002 Manthri",
    placementCode: "--",
    jobTitle: "Lead Developer",
    billableClient: "ShubhaMinds, LLC",
    projectTitle: "--",
    jobStatus: "Active",
    startDate: "2023-09-08T00:00:00.000Z",
    endDate: "2025-05-10T00:00:00.000Z",
    projectedEndDate: "2024-12-14T00:00:00.000Z",
    payRate: "40.80",
    billRate: "60.00",
    paymentEffectiveDate: "2025-10-05T00:00:00.000Z",
  },
  {
    jobCode: "shu-003 Manthri",
    placementCode: "--",
    jobTitle: "Lead Developer",
    billableClient: "ShubhaMinds, LLC",
    projectTitle: "--",
    jobStatus: "Active",
    startDate: "2023-09-08T00:00:00.000Z",
    endDate: "2025-05-10T00:00:00.000Z",
    projectedEndDate: "2024-12-14T00:00:00.000Z",
    payRate: "40.80",
    billRate: "60.00",
    paymentEffectiveDate: "2025-10-05T00:00:00.000Z",
  },
];

export const vendorData = [
  {
    name: "John Doe",
    email: "johndoe@example.com",
    jobTitle: "Software Engineer",
    phone: "+1 123-456-7890",
    joiningDate: "2025-02-10T18:30:00.000Z",
  },
  {
    name: "Alice Smith",
    email: "alice.smith@example.com",
    jobTitle: "Frontend Developer",
    phone: "+44 7894-567-890",
    joiningDate: "2025-03-15T18:30:00.000Z",
  },
  {
    name: "Ravi Kumar",
    email: "ravi.kumar@example.com",
    jobTitle: "Backend Developer",
    phone: "+91 98765-43210",
    joiningDate: "2025-04-20T18:30:00.000Z",
  },
  {
    name: "Emily Johnson",
    email: "emily.johnson@example.com",
    jobTitle: "Full Stack Developer",
    phone: "+1 345-678-9012",
    joiningDate: "2025-05-05T18:30:00.000Z",
  },
];

export const accordionData = [
  {
    id: 1,
    employeeName: "Abhiram Tayi",
    jobCode: "Ver-001",
    jobTitle: "Dev_collabera",
    startDate: "2021-08-11T00:00:00.000Z",
    endDate: "2025-09-21T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 2,
    employeeName: "Rohit Sharma",
    jobCode: "Ver-002",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-01T00:00:00.000Z",
    endDate: "2025-09-15T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 3,
    employeeName: "John Doe",
    jobCode: "Ver-003",
    jobTitle: "Dev_collabera",
    startDate: "2021-08-15T00:00:00.000Z",
    endDate: "2025-09-10T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 4,
    employeeName: "Jane Smith",
    jobCode: "Ver-004",
    jobTitle: "Dev_collabera",
    startDate: "2021-08-20T00:00:00.000Z",
    endDate: "2025-09-05T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 5,
    employeeName: "Michael Johnson",
    jobCode: "Ver-005",
    jobTitle: "Dev_collabera",
    startDate: "2021-08-25T00:00:00.000Z",
    endDate: "2025-09-01T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 6,
    employeeName: "Emily Davis",
    jobCode: "Ver-006",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-05T00:00:00.000Z",
    endDate: "2025-08-28T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 7,
    employeeName: "David Wilson",
    jobCode: "Ver-007",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-10T00:00:00.000Z",
    endDate: "2025-08-25T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 8,
    employeeName: "Sophia Brown",
    jobCode: "Ver-008",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-15T00:00:00.000Z",
    endDate: "2025-08-20T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 9,
    employeeName: "Daniel Martinez",
    jobCode: "Ver-009",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-20T00:00:00.000Z",
    endDate: "2025-08-15T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 10,
    employeeName: "Olivia Thomas",
    jobCode: "Ver-010",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-25T00:00:00.000Z",
    endDate: "2025-08-10T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 11,
    employeeName: "Liam Garcia",
    jobCode: "Ver-011",
    jobTitle: "Dev_collabera",
    startDate: "2021-09-30T00:00:00.000Z",
    endDate: "2025-08-05T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 12,
    employeeName: "Ava Rodriguez",
    jobCode: "Ver-012",
    jobTitle: "Dev_collabera",
    startDate: "2021-10-05T00:00:00.000Z",
    endDate: "2025-08-01T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 13,
    employeeName: "Noah Lee",
    jobCode: "Ver-013",
    jobTitle: "Dev_collabera",
    startDate: "2021-10-10T00:00:00.000Z",
    endDate: "2025-07-28T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 14,
    employeeName: "Isabella Hernandez",
    jobCode: "Ver-014",
    jobTitle: "Dev_collabera",
    startDate: "2021-10-15T00:00:00.000Z",
    endDate: "2025-07-25T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 15,
    employeeName: "James Young",
    jobCode: "Ver-015",
    jobTitle: "Dev_collabera",
    startDate: "2021-10-20T00:00:00.000Z",
    endDate: "2025-07-20T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 16,
    employeeName: "Charlotte King",
    jobCode: "Ver-016",
    jobTitle: "Dev_collabera",
    startDate: "2021-10-25T00:00:00.000Z",
    endDate: "2025-07-15T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
  {
    id: 17,
    employeeName: "Benjamin Wright",
    jobCode: "Ver-017",
    jobTitle: "Dev_collabera",
    startDate: "2021-11-01T00:00:00.000Z",
    endDate: "2025-07-10T00:00:00.000Z",
    approvals: "Hemalathe Medishetti,Abhi Y",
  },
];

export const approvalDelegationData = [
  {
    id: 1,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 2,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 3,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 4,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 5,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 6,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 7,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 8,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 9,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 10,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  },
];
export const delegationData = [
  {
    id: 1,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 2,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 3,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 4,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Team Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 5,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 6,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 7,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 8,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 9,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075) Lead",
  },
  {
    id: 10,
    employeeName: "Abdul Waseem Syed (EMP-1001)",
    DelegationOnBehalf: "Hemalatha Medisetti (EMP-075)",
  },
];

export const additionalNotifiers = [
  {
    id: 1,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "Permanent Placement",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 2,
    employeeName: "Abdul Muqeeth",
    employmentType: "Contractor",
    category: "--",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 3,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "C2C",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 4,
    employeeName: "Abdul Muqeeth",
    employmentType: "Contractor",
    category: "W2",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 5,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "Tektree-Internal",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 6,
    employeeName: "Abdul Muqeeth",
    employmentType: "Employee",
    category: "W2",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 7,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "--",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 8,
    employeeName: "Abdul Muqeeth",
    employmentType: "Contractor",
    category: "Permanent Placement",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 9,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "Permanent Placement",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 10,
    employeeName: "Abdul Muqeeth",
    employmentType: "Contractor",
    category: "W2",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 11,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "Permanent Placement",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 12,
    employeeName: "Abdul Muqeeth",
    employmentType: "Employee",
    category: "--",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 13,
    employeeName: "Aaron Carter",
    employmentType: "Contractor",
    category: "--",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 14,
    employeeName: "Abdul Muqeeth",
    employmentType: "--",
    category: "W2",
    additionalNotifiers: "--",
    Actions: "add",
  },
  {
    id: 15,
    employeeName: "Aaron Carter",
    employmentType: "--",
    category: "Tektree-Internal",
    additionalNotifiers: "--",
    Actions: "add",
  },
];

export const revisionHistoryrowdata = [
  {
    PaymentType: "Based On Placement",
    TotalSalary: "0.00",
    SalaryPerCycle: "0.00",
    TotalBasePay: 8470.83,
    BasePayPerCycle: 8470.83,
    SalaryLessThanBasePay: "Pay the Total Base Pay Amount Configured",
    SalaryGreaterThanBasePay: "Hold the excess amount for future",
    RevisePayCycle: "05/01/2021-05/31/2021",
    DiemPaymentType: "Not Appllicable",
    NoOfCyclesRun: 46,
    CreatedOn: "06/03/2021",
  },
];
export const employeePaymentDetailsrowData = [
  {
    id: 1,
    JobTitle: "Siebel Lead Developer",
    Client: "Shuvhaminds LLC",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 160,
    PayRate: "$40.80",
    Total: "$6,528.00",
  },
  {
    id: 2,
    JobTitle: "React Developer",
    Client: "TechNova Inc.",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 168,
    PayRate: "$45.00",
    Total: "$7,560.00",
  },
  {
    id: 3,
    JobTitle: "Full Stack Engineer",
    Client: "Innovent Solutions",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 150,
    PayRate: "$50.00",
    Total: "$7,500.00",
  },
  {
    id: 4,
    JobTitle: "Data Analyst",
    Client: "Insight Analytics",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 160,
    PayRate: "$38.00",
    Total: "$6,080.00",
  },
  {
    id: 5,
    JobTitle: "QA Automation Engineer",
    Client: "ByteCheck Solutions",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 162,
    PayRate: "$42.00",
    Total: "$6,804.00",
  },
  {
    id: 6,
    JobTitle: "DevOps Engineer",
    Client: "CloudMatrix Corp.",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 170,
    PayRate: "$52.00",
    Total: "$8,840.00",
  },
  {
    id: 7,
    JobTitle: "Project Manager",
    Client: "PrimeTech Solutions",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 160,
    PayRate: "$60.00",
    Total: "$9,600.00",
  },
  {
    id: 8,
    JobTitle: "UI/UX Designer",
    Client: "PixelCraft Studio",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 155,
    PayRate: "$48.00",
    Total: "$7,440.00",
  },
  {
    id: 9,
    JobTitle: "Backend Engineer",
    Client: "TechHive LLC",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 165,
    PayRate: "$47.00",
    Total: "$7,755.00",
  },
  {
    id: 10,
    JobTitle: "System Administrator",
    Client: "ByteCore Solutions",
    PayCycle: "02/01/2025 - 02/28/2025",
    Classification: "Standard Time",
    TotalHours: 160,
    PayRate: "$44.00",
    Total: "$7,040.00",
  },
];

export const otherpaymentrows = [
  {
    PayCycle: "01/01/2025-02/28/2025",
    PayDate: "03/12/2025",
    Earnings: 16140.88,
    Payment: 16140.88,
    OtherPaymentPaid: 0.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "Regular monthly payout.",
    OtherPaymentAccumulatedthisCycles: 0.0,
  },
  {
    PayCycle: "03/01/2025-03/31/2025",
    PayDate: "04/10/2025",
    Earnings: 14500.0,
    Payment: 14500.0,
    OtherPaymentPaid: 500.0,
    ModeofPayment: "separate",
    OtherPaymentcomments: "Bonus payout included.",
    OtherPaymentAccumulatedthisCycles: 500.0,
  },
  {
    PayCycle: "04/01/2025-04/30/2025",
    PayDate: "05/12/2025",
    Earnings: 15200.5,
    Payment: 15000.5,
    OtherPaymentPaid: 200.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "Adjustment for travel.",
    OtherPaymentAccumulatedthisCycles: 700.0,
  },
  {
    PayCycle: "05/01/2025-05/31/2025",
    PayDate: "06/11/2025",
    Earnings: 16850.75,
    Payment: 16850.75,
    OtherPaymentPaid: 0.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "Full salary, no extras.",
    OtherPaymentAccumulatedthisCycles: 700.0,
  },
  {
    PayCycle: "06/01/2025-06/30/2025",
    PayDate: "07/10/2025",
    Earnings: 17420.0,
    Payment: 17000.0,
    OtherPaymentPaid: 420.0,
    ModeofPayment: "separate",
    OtherPaymentcomments: "Reimbursement issued.",
    OtherPaymentAccumulatedthisCycles: 1120.0,
  },
  {
    PayCycle: "07/01/2025-07/31/2025",
    PayDate: "08/12/2025",
    Earnings: 18000.0,
    Payment: 18000.0,
    OtherPaymentPaid: 0.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "No other payments this cycle.",
    OtherPaymentAccumulatedthisCycles: 1120.0,
  },
  {
    PayCycle: "08/01/2025-08/31/2025",
    PayDate: "09/11/2025",
    Earnings: 18250.0,
    Payment: 18250.0,
    OtherPaymentPaid: 300.0,
    ModeofPayment: "separate",
    OtherPaymentcomments: "Incentive payout.",
    OtherPaymentAccumulatedthisCycles: 1420.0,
  },
  {
    PayCycle: "09/01/2025-09/30/2025",
    PayDate: "10/10/2025",
    Earnings: 17890.0,
    Payment: 17500.0,
    OtherPaymentPaid: 390.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "Overtime adjustment.",
    OtherPaymentAccumulatedthisCycles: 1810.0,
  },
  {
    PayCycle: "10/01/2025-10/31/2025",
    PayDate: "11/12/2025",
    Earnings: 19000.0,
    Payment: 19000.0,
    OtherPaymentPaid: 0.0,
    ModeofPayment: "with payroll",
    OtherPaymentcomments: "Standard payroll.",
    OtherPaymentAccumulatedthisCycles: 1810.0,
  },
  {
    PayCycle: "11/01/2025-11/30/2025",
    PayDate: "12/10/2025",
    Earnings: 19200.0,
    Payment: 19000.0,
    OtherPaymentPaid: 200.0,
    ModeofPayment: "separate",
    OtherPaymentcomments: "Year-end bonus.",
    OtherPaymentAccumulatedthisCycles: 2010.0,
  },
];

export const PreviouspaydetailsRowsdata = [
  {
    employeeName: "Ramesh Manthri(con-2064)",
    payfrequency: "Monthly",
    type: "other payment",
    paycycle: "02/01/2015-05/06/2019",
    payDate: "02/05/2023",
    employeeearnings: 8785.65,
    salary: 8785.6,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 0.0,
    expenses: 0.0,
  },
  {
    employeeName: "Sita Reddy(con-2089)",
    payfrequency: "Weekly",
    type: "advance",
    paycycle: "01/01/2022-01/07/2022",
    payDate: "01/10/2022",
    employeeearnings: 4300.0,
    salary: 4200.0,
    advancePayments: 100.0,
    advancePaymentdeductions: 50.0,
    deductions: 75.0,
    expenses: 20.0,
  },
  {
    employeeName: "John Paul(con-2090)",
    payfrequency: "Bi-weekly",
    type: "bonus",
    paycycle: "03/01/2023-03/15/2023",
    payDate: "03/16/2023",
    employeeearnings: 5000.0,
    salary: 4500.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 200.0,
    expenses: 100.0,
  },
  {
    employeeName: "Priya Sharma(con-2091)",
    payfrequency: "Monthly",
    type: "other payment",
    paycycle: "04/01/2023-04/30/2023",
    payDate: "05/01/2023",
    employeeearnings: 7200.5,
    salary: 7000.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 100.0,
    expenses: 50.0,
  },
  {
    employeeName: "Akash Varma(con-2092)",
    payfrequency: "Weekly",
    type: "advance",
    paycycle: "05/01/2023-05/07/2023",
    payDate: "05/08/2023",
    employeeearnings: 3100.0,
    salary: 3000.0,
    advancePayments: 150.0,
    advancePaymentdeductions: 100.0,
    deductions: 25.0,
    expenses: 0.0,
  },
  {
    employeeName: "Latha Devi(con-2093)",
    payfrequency: "Bi-weekly",
    type: "other payment",
    paycycle: "06/01/2023-06/14/2023",
    payDate: "06/15/2023",
    employeeearnings: 6500.0,
    salary: 6400.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 50.0,
    expenses: 30.0,
  },
  {
    employeeName: "Rajeev Patil(con-2094)",
    payfrequency: "Monthly",
    type: "bonus",
    paycycle: "07/01/2023-07/31/2023",
    payDate: "08/01/2023",
    employeeearnings: 9000.0,
    salary: 8500.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 200.0,
    expenses: 100.0,
  },
  {
    employeeName: "Divya Nair(con-2095)",
    payfrequency: "Weekly",
    type: "advance",
    paycycle: "08/01/2023-08/07/2023",
    payDate: "08/08/2023",
    employeeearnings: 3500.0,
    salary: 3300.0,
    advancePayments: 200.0,
    advancePaymentdeductions: 150.0,
    deductions: 30.0,
    expenses: 25.0,
  },
  {
    employeeName: "Vikram Iyer(con-2096)",
    payfrequency: "Bi-weekly",
    type: "other payment",
    paycycle: "09/01/2023-09/14/2023",
    payDate: "09/15/2023",
    employeeearnings: 7800.0,
    salary: 7700.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 50.0,
    expenses: 20.0,
  },
  {
    employeeName: "Meena Choudhary(con-2097)",
    payfrequency: "Monthly",
    type: "bonus",
    paycycle: "10/01/2023-10/31/2023",
    payDate: "11/01/2023",
    employeeearnings: 8600.0,
    salary: 8000.0,
    advancePayments: 0.0,
    advancePaymentdeductions: 0.0,
    deductions: 300.0,
    expenses: 120.0,
  },
];

export const employepaymentDataMODEL = [
  {
    date: "02/01/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "paid from Paydata",
  },
  {
    date: "02/02/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "overtime",
    Hours: 2.0,
    billRate: "$55/hr",
  },
  {
    date: "02/03/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 7.5,
    billRate: "$50/hr",
  },
  {
    date: "02/04/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "holiday",
    Hours: 8.0,
    billRate: "$60/hr",
  },
  {
    date: "02/05/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "paid from Paydata",
  },
  {
    date: "02/06/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "training",
    Hours: 4.0,
    billRate: "$30/hr",
  },
  {
    date: "02/07/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 6.5,
    billRate: "$48/hr",
  },
  {
    date: "02/08/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "overtime",
    Hours: 3.0,
    billRate: "$55/hr",
  },
  {
    date: "02/09/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "paid from Paydata",
  },
  {
    date: "02/10/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 7.75,
    billRate: "$50/hr",
  },
  {
    date: "02/11/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "holiday",
    Hours: 8.0,
    billRate: "$60/hr",
  },
  {
    date: "02/12/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "$50/hr",
  },
  {
    date: "02/13/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "sick leave",
    Hours: 8.0,
    billRate: "N/A",
  },
  {
    date: "02/14/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "paid from Paydata",
  },
  {
    date: "02/15/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 6.0,
    billRate: "$48/hr",
  },
  {
    date: "02/16/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "overtime",
    Hours: 2.0,
    billRate: "$55/hr",
  },
  {
    date: "02/17/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "$50/hr",
  },
  {
    date: "02/18/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "holiday",
    Hours: 8.0,
    billRate: "$60/hr",
  },
  {
    date: "02/19/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 7.0,
    billRate: "$50/hr",
  },
  {
    date: "02/20/2025",
    Placement:
      "technical consultant computer inc for computer aid inc | cai-001",
    Classification: "standard time",
    Hours: 8.0,
    billRate: "paid from Paydata",
  },
];

export const otherpaymentData = [
  {
    empCode: "Emp-001",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-002",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-003",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-004",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-005",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-006",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-007",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-008",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-009",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
  {
    empCode: "Emp-010",
    empName: "Vikranth Desireddy",
    deductions: "$3200",
    healthInsurance: "$500",
    shortPayments: "$-100",
    excessPayments: "$500",
    unpaidTimesheers: "$30,000",
  },
];

export const Employepaymentdetailsrows = [
  {
    NameinBankAccount: "John Doe",
    BankName: "Bank of America",
    AccountType: "Checking",
    AccountNumber: "123456789",
    DepositAmount: "$2,000.00",
    Address: "123 Main St, New York, NY 10001",
    Status: "Active",
  },
];
export const paymentmodelrows = [
  {
    Date: " 03/11/2025",
    ReceivedAmount: " 5134.00 USD",
    ReferenceNumber: " ",
    WaveoffAmount: " ",
    WaveoffReason: " ",
    WaveoffComments: " ",
  },
];
export const intialduedaterows = [
  {
    DueDate: "02/11/2025",
    UpdatedBy: "Vikranth Desireddy",
    UpdatedOn: "03/11/2025 10:47:20",
  },
];
export const allBillsrowdata = [
  {
    id: 1,
    InvoiceNumber: "16444",
    Employees: "Srujana Gudla(Emo-1018)",
    Vendor: "Tekintegral Inc",
    VendorID: "V-2752",
    InvoiceDate: "04/04/2025",
    InvoiceDueDate: "05/19/2025",
    BillAmount: "12768.00 USD",
    PaidAmount: "00.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "12768.00",
  },
  {
    id: 2,
    InvoiceNumber: "16445",
    Employees: "John Doe(Emo-1020)",
    Vendor: "CodeWorks LLC",
    VendorID: "V-2753",
    InvoiceDate: "04/05/2025",
    InvoiceDueDate: "05/20/2025",
    BillAmount: "5400.00 USD",
    PaidAmount: "00.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "5400.00",
  },
  {
    id: 3,
    InvoiceNumber: "16446",
    Employees: "Jane Smith(Emo-1021)",
    Vendor: "TechNode Inc",
    VendorID: "V-2754",
    InvoiceDate: "04/06/2025",
    InvoiceDueDate: "05/21/2025",
    BillAmount: "8900.00 USD",
    PaidAmount: "1000.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "7900.00",
  },
  {
    id: 4,
    InvoiceNumber: "16447",
    Employees: "Robert Miles(Emo-1022)",
    Vendor: "DevStream Ltd",
    VendorID: "V-2755",
    InvoiceDate: "04/07/2025",
    InvoiceDueDate: "05/22/2025",
    BillAmount: "10000.00 USD",
    PaidAmount: "2000.00 USD",
    DiscountAmount: "500.00 USD",
    DueAmount: "7500.00",
  },
  {
    id: 5,
    InvoiceNumber: "16448",
    Employees: "Alice Ray(Emo-1023)",
    Vendor: "Innovix Group",
    VendorID: "V-2756",
    InvoiceDate: "04/08/2025",
    InvoiceDueDate: "05/23/2025",
    BillAmount: "11200.00 USD",
    PaidAmount: "00.00 USD",
    DiscountAmount: "1200.00 USD",
    DueAmount: "10000.00",
  },
  {
    id: 6,
    InvoiceNumber: "16449",
    Employees: "Mark Levin(Emo-1024)",
    Vendor: "NextSoft Corp",
    VendorID: "V-2757",
    InvoiceDate: "04/09/2025",
    InvoiceDueDate: "05/24/2025",
    BillAmount: "7300.00 USD",
    PaidAmount: "00.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "7300.00",
  },
  {
    id: 7,
    InvoiceNumber: "16450",
    Employees: "Sophia White(Emo-1025)",
    Vendor: "PixelEdge Inc",
    VendorID: "V-2758",
    InvoiceDate: "04/10/2025",
    InvoiceDueDate: "05/25/2025",
    BillAmount: "6900.00 USD",
    PaidAmount: "6900.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "00.00",
  },
  {
    id: 8,
    InvoiceNumber: "16451",
    Employees: "Liam Grey(Emo-1026)",
    Vendor: "BitBridge LLC",
    VendorID: "V-2759",
    InvoiceDate: "04/11/2025",
    InvoiceDueDate: "05/26/2025",
    BillAmount: "8800.00 USD",
    PaidAmount: "3000.00 USD",
    DiscountAmount: "800.00 USD",
    DueAmount: "5000.00",
  },
  {
    id: 9,
    InvoiceNumber: "16452",
    Employees: "Emma Black(Emo-1027)",
    Vendor: "TechNest Pvt Ltd",
    VendorID: "V-2760",
    InvoiceDate: "04/12/2025",
    InvoiceDueDate: "05/27/2025",
    BillAmount: "9500.00 USD",
    PaidAmount: "00.00 USD",
    DiscountAmount: "00.00 USD",
    DueAmount: "9500.00",
  },
  {
    id: 10,
    InvoiceNumber: "16453",
    Employees: "Noah Green(Emo-1028)",
    Vendor: "NovaTech Solutions",
    VendorID: "V-2761",
    InvoiceDate: "04/13/2025",
    InvoiceDueDate: "05/28/2025",
    BillAmount: "12000.00 USD",
    PaidAmount: "5000.00 USD",
    DiscountAmount: "1000.00 USD",
    DueAmount: "6000.00",
  },
];
export const paymentrowData = [
  {
    id: 1,
    Description: "Web Design Services",
    DueDate: "2025-05-15",
    OriginalAmount: "2000",
    PaymentReceived: "500",
    OpenBalance: "1500",
    EnterPaymentAmount: "1000",
    PaymentDiscount: "100",
    PaidAmount: "900",
  },
];
export const paymentrowdata = [
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
  {
    InvoiceNumber: "86864810",
    PaymentDate: " 03/26/2025",
    PaymentMethod: "ACH",
    BillAmount: " 5134.00 USD",
    PaidAmount: "5134.00 USD",
    CreatedOn: "03/26/2025",
    ModifiedOn: "03/26/2025",
    ReferenceNumber: "-",
    Note: "-",
  },
];
export const Attachmentrows = [
  {
    dateAndTime: "03/26/2025 03:52:36",
    Discription: "An attachment [Deloitteinvoice.pdf] has been added.",
    UpdatedBy: "Vikranth Desireddy",
  },
  {
    dateAndTime: "03/26/2025 03:48:36",
    Discription:
      "A new accounts payable with invoice number 86864813 is Created by Vikranth Desireddy and Bill Amount has been added manually.",
    UpdatedBy: "Vikranth Desireddy",
  },
];

export const Accountpayablesettingrows = [
  {
    id: 1,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 2,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 3,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 4,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 5,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 6,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 7,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 8,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 9,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 10,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 11,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 12,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
  {
    id: 13,
    EmployeeName: " Abdul Waseem Syed (EMP-1001)",
    ApprovalDelegation: " Hemalatha Medisetti (EMP-075)",
  },
];

export const ApprovalDetailsTableData = [
  {
    Product: "Adeed Khan",
    Discription: "(11/17/2024 to 12/14/2024)",
    Quantity: "114",
    Rate: "48.00",
    Amount: "6912.00",
    client: "Milliennium software Inc",
    AccountTypes: "-",
  },
];

export const BulkInvoicesRows = [
  {
    InvoicePreview: " ",
    Employee: " ",
    JobTitle: " ",
    Client: " ",
    InvoiceFrequency: " ",
    InvoicePeriod: " ",
    TimesheetDates: " ",
    TotalHours: " ",
  },
];

export const Eonboardingdashoboard = [
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Active",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Rejected",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Inactive",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Submitted",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Rejected",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Joined",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "On hold",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Inactive",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Joined",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Joined",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Joined",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Joined",
  },
  {
    Name: "Sajida",
    Email: "sajida@gmail.com",
    JobTitle: "Video Editor",
    Phone: "9854684512",
    JoiningDate: "26/12/2024",
    Status: "Submitted",
  },
];

export const immigrationrowdata = [
  {
    employeeName: "John Doe",
    RecordStatus: "Active",
    EmployeeType: "Employee",
    Status: "I-485 - Approved",
    AppliedOn: "2023-08-15",
    PriorityDate: "2023-09-01",
    Comments: "-",
  },
  {
    employeeName: "Jane Smith",
    RecordStatus: "Active",
    EmployeeType: "Employee",
    Status: "I-485 - Approved",
    AppliedOn: "2024-01-10",
    PriorityDate: "2024-02-20",
    Comments: "-",
  },
  {
    employeeName: "Michael Johnson",
    RecordStatus: "Active",
    EmployeeType: "Employee",
    Status: "I-485 - Approved",
    AppliedOn: "2022-11-05",
    PriorityDate: "2023-01-10",
    Comments: "-",
  },
  {
    employeeName: "Emily Davis",
    RecordStatus: "Active",
    EmployeeType: "Employee",
    Status: "I-485 - Approved",
    AppliedOn: "2024-05-01",
    PriorityDate: "2024-06-15",
    Comments: "-",
  },
  {
    employeeName: "Carlos Ramirez",
    RecordStatus: "Active",
    EmployeeType: "Employee",
    Status: "I-485 - Approved",
    AppliedOn: "2023-04-18",
    PriorityDate: "2023-05-22",
    Comments: "-",
  },
];

export const eonboardingdocunebts = [
  {
    name: "Onboarding Checklist",
    description: "Checklist for new employee onboarding process.",
    supportingDocuments: "test supporting documents",
    createdBy: "jane.smith@example.com",
    CreatedOn: "2025/05/28",
  },
  {
    name: "Marketing Plan",
    description: "Strategic marketing plan for Q3 campaigns.",
    supportingDocuments: "marketing_q3_plan.pdf",
    createdBy: "alex.johnson@example.com",
    CreatedOn: "2025/05/20",
  },
  {
    name: "Technical Specification",
    description: "Specs for the new internal HR tool.",
    supportingDocuments: "hr_tool_spec.docx",
    createdBy: "lisa.wong@example.com",
    CreatedOn: "2025/05/15",
  },
  {
    name: "Client Contract",
    description: "Signed contract with ABC Corporation.",
    supportingDocuments: "abc_contract_signed.pdf",
    createdBy: "michael.brown@example.com",
    CreatedOn: "2025/04/30",
  },
  {
    name: "Annual Report",
    description: "Full-year financial and operations summary.",
    supportingDocuments: "annual_report_2024.pdf",
    createdBy: "sarah.davis@example.com",
    CreatedOn: "2025/03/31",
  },
];

export const eonboardingactivites = [
  {
    date: "13/2/2025 1:55 pm",
    record: "Configuration > Document Types > Test Category",
    description:
      "Added supporting documents Test supporting document and Addedmandatory support",
    actionBy: "Abhi Y",
  },
  {
    date: "13/2/2025 1:55 pm",
    record: "Configuration > Document Types > Test Category",
    description:
      "Added supporting documents Test supporting document and Addedmandatory support",
    actionBy: "Abhi Y",
  },
  {
    date: "13/2/2025 1:55 pm",
    record: "Configuration > Document Types > Test Category",
    description:
      "Added supporting documents Test supporting document and Addedmandatory support",
    actionBy: "Abhi Y",
  },
  {
    date: "13/2/2025 1:55 pm",
    record: "Configuration > Document Types > Test Category",
    description:
      "Added supporting documents Test supporting document and Addedmandatory support",
    actionBy: "Abhi Y",
  },
];

export const employeePlacementDetails = [
  {
    placementTitle: "Siebel Lead Developer",
    client: "Shuba Minds, LLC",
    jobStartDate: "01/31/2023",
    jobEndDate: "02/17/2025",
    billRate: "60.00",
    payRate: "CLN-250",
  },
  {
    placementTitle: "Siebel Lead Developer",
    client: "Shuba Minds, LLC",
    jobStartDate: "01/31/2023",
    jobEndDate: "02/17/2025",
    billRate: "60.00",
    payRate: "CLN-250",
  },
];

export const employeePaymentRows = [
  {
    period: "january 2025",
    payDay: "Feb 2025",
    payPeriod: "06/06/2021 - 06/30/2021",
    paymentFrequency: "Monthly",
    paymentType: "Hourly",
    amount: "11689.44",
  },
  {
    period: "january 2025",
    payDay: "Feb 2025",
    payPeriod: "06/06/2021 - 06/30/2021",
    paymentFrequency: "Monthly",
    paymentType: "Hourly",
    amount: "11689.44",
  },
];

export const invoicePaymentRows = [
  {
    Period: "Dec 2025",
    receivedDate: "01/31/2025",
    placementTitle: "Software Engineer III_Seaglass",
    client: "Computer Aid Inc",
    timesheetPeriod: "06/06/2021 - 06/30/2021",
    hoursReceived: "172",
    amount: "1849.60",
  },
  {
    Period: "Jan 2025",
    receivedDate: "01/31/2025",
    placementTitle: "Software Engineer III_Seaglass",
    client: "Computer Aid Inc",
    timesheetPeriod: "06/06/2021 - 06/30/2021",
    hoursReceived: "172",
    amount: "1849.60",
  },
];

export const advancePaymentsRows = [
  {
    date: "01/31/2023",
    advancePaymentName: "H1B Extension 2023",
    amount: "3630.00",
    recoveredAmount: "3630.00",
    balanceAmount: "0.00",
  },
  {
    date: "01/31/2023",
    advancePaymentName: "H1B Extension 2023",
    amount: "3630.00",
    recoveredAmount: "3630.00",
    balanceAmount: "0.00",
  },
];

export const OtherPaymentRows = [
  {
    jobstartdate: "Jan 2025",
    jobenddate: "Jan 2025",
    paymentype: "otherpayments",
    amount: "1849.60",
  },
  {
    jobstartdate: "Jan 2025",
    jobenddate: "Jan 2025",
    paymentype: "otherpayments",
    amount: "1849.60",
  },
];

export const employeeDeductionsRows = [
  {
    date: "01/31/2023",
    deductionName: "Pranathi Penmetcha Regular Payroll",
    type: "Pre-Tax Deduction",
    amount: "7000.00",
    recoveredAmount: "77000.00",
    balanceAmount: "-70000.00",
  },
  {
    date: "01/31/2023",
    deductionName: "Pranathi Penmetcha Regular Payroll",
    type: "Pre-Tax Deduction",
    amount: "7000.00",
    recoveredAmount: "77000.00",
    balanceAmount: "-70000.00",
  },
];

export const miscellaneousPaymentsRows = [
  {
    date: "2025-04-01",
    miscPaymentName: "Uniform Allowance",
    taxApplicability: "Taxable",
    paymentMode: "Bank Transfer",
    amount: 100.0,
    paidAmount: 70.0,
    balanceAmount: 10.0,
  },
  {
    date: "2025-04-01",
    miscPaymentName: "Uniform Allowance",
    taxApplicability: "Taxable",
    paymentMode: "Bank Transfer",
    amount: 100.0,
    paidAmount: 70.0,
    balanceAmount: 10.0,
  },
];

export const expensesRows = [
  {
    period: "2025-04",
    placement: "Software Developer - ABC Corp",
    expenseId: "EXP123456",
    expenseDetails: "Laptop Purchase",
    amountSubmitted: 1200.0,
    amountApproved: 1000.0,
    amountBillable: 1000.0,
    amountPayable: 950.0,
    status: "Approved",
    paidDate: "2025-04-15",
  },
  {
    period: "2025-04",
    placement: "Software Developer - ABC Corp",
    expenseId: "EXP123456",
    expenseDetails: "Laptop Purchase",
    amountSubmitted: 1200.0,
    amountApproved: 1000.0,
    amountBillable: 1000.0,
    amountPayable: 950.0,
    status: "Approved",
    paidDate: "2025-04-15",
  },
];

export const perDiemRows = [
  {
    payDay: "01/31/2023",
    payPeriod: "06/06/2021 - 06/30/2021",
    amount: "0.00",
  },
  {
    payDay: "01/31/2023",
    payPeriod: "06/06/2021 - 06/30/2021",
    amount: "0.00",
  },
];

export const commissionRows = [
  {
    payDay: "01/31/2023",
    payPeriod: "06/06/2021 - 06/30/2021",
    amount: "0.00",
  },
  {
    payDay: "01/31/2023",
    payPeriod: "06/06/2021 - 06/30/2021",
    amount: "0.00",
  },
];

export const PlacementDetailsRows = [
  {
    date: "2025-04-05",
    Transaction: "invoice amount received",
    Description: "17492 (client name: Infoworks Systems Inc.)",
    Type: "Shubha Minds, LLC",
    TransactionAmount: 150.0,
    Payrate: "CLS-300",
  },
  {
    date: "2025-04-10",
    Transaction: "bonus payment received",
    Description: "17601 (client name: CodeGen Solutions Pvt Ltd)",
    Type: "Shubha Minds, LLC",
    TransactionAmount: 75.5,
    Payrate: "CLS-220",
  },
  {
    date: "2025-04-15",
    Transaction: "invoice amount received",
    Description: "17834 (client name: Blue Ocean Technologies)",
    Type: "Shubha Minds, LLC",
    TransactionAmount: 200.0,
    Payrate: "CLS-280",
  },
  {
    date: "2025-04-18",
    Transaction: "advance cleared",
    Description: "17920 (client name: TechValley Solutions)",
    Type: "Shubha Minds, LLC",
    TransactionAmount: 120.0,
    Payrate: "CLS-260",
  },
  {
    date: "2025-04-22",
    Transaction: "invoice amount received",
    Description: "18109 (client name: NexGen Cloud LLC)",
    Type: "Shubha Minds, LLC",
    TransactionAmount: 175.0,
    Payrate: "CLS-240",
  },
];

export const salaryptofilerows = [
  {
    PayPeriods: "01/01/2025 - 01/30/2025",
    ActualPayDays: "01/31/2025",
    PayDays: "01/31/2025",
  },
  {
    PayPeriods: "01/01/2025 - 01/30/2025",
    ActualPayDays: "01/31/2025",
    PayDays: "01/31/2025",
  },
  {
    PayPeriods: "01/01/2025 - 01/30/2025",
    ActualPayDays: "01/31/2025",
    PayDays: "01/31/2025",
  },
  {
    PayPeriods: "01/01/2025 - 01/30/2025",
    ActualPayDays: "01/31/2025",
    PayDays: "01/31/2025",
  },
];

export const recviedpaymentmodelrows = [
  {
    Description: "H1B CASE 2022",
    Installments: "9/10",
    OrinalAmount: "10,000",
    OpenBalance: "1000",
  },
  {
    Description: "H1B CASE 2022",
    Installments: "9/10",
    OrinalAmount: "10,000",
    OpenBalance: "1000",
  },
  {
    Description: "H1B CASE 2022",
    Installments: "9/10",
    OrinalAmount: "10,000",
    OpenBalance: "1000",
  },
  {
    Description: "H1B CASE 2022",
    Installments: "9/10",
    OrinalAmount: "10,000",
    OpenBalance: "1000",
  },
];

export const PayPeriodRows = [
  {
    payday: "2025-04-05",
    payperiod: ["2025-04-05", "2025-04-05"],
  },
  {
    payday: "2025-04-05",
    payperiod: ["2025-04-05", "2025-04-05"],
  },
  {
    payday: "2025-04-05",
    payperiod: ["2025-04-05", "2025-04-05"],
  },
  {
    payday: "2025-04-05",
    payperiod: ["2025-04-05", "2025-04-05"],
  },
  {
    payday: "2025-04-05",
    payperiod: ["2025-04-05", "2025-04-05"],
  },
];

export const accountpayableadjustmenttableData1 = [
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty: "-1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty: "-1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty: "-1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty: "-1200",
  },
];
export const accountpayableadjustmenttableData2 = [
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty1: "+1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty1: "+1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty1: "+1200",
  },
  {
    jobTitle: "Sales Manager",
    clientName: "Seaglass",
    period: "01/01/2024 - 12/31/2024",
    originalHours: 176,
    revisedHours: 168,
    originalPay: "11200",
    revisedPay: "10000",
    difference: "1200",
    empty1: "+1200",
  },
];

export const upcommingpaydaytableData = [
  {
    payDay: "2025-04-14T00:00:00.000Z",
    payPeriod: "2025-03-16T00:00:00.000Z TO 2025-03-31T00:00:00.000Z",
    linkedEmployees: "1",
    payProfile: "Bi-Monthly (W2)",
    payFrequency: "Semi Monthly",
    unpaidEmpoyees: "1",
    totalPayrollAmount: "00.00",
    totalPayout: "0.00",
    pendingPayout: "-19,437.66",
    lastUpdate: "2025-04-14T00:00:00.000Z",
  },
  {
    payDay: "2025-04-14T00:00:00.000Z",
    payPeriod: "2025-03-16T00:00:00.000Z TO 2025-03-31T00:00:00.000Z",
    linkedEmployees: "57",
    payProfile: "W2 Payroll (Monthly)",
    payFrequency: "Monthly",
    unpaidEmpoyees: "57",
    totalPayrollAmount: "00.00",

    totalPayout: "-19,473.66",
    pendingPayout: "-19,437.66",

    lastUpdate: "2025-04-14T00:00:00.000Z",
  },
];

export const pastpaydaytableData = [
  {
    payDay: "2025-04-14T00:00:00.000Z",
    payPeriod: "2025-03-16T00:00:00.000Z TO 2025-03-31T00:00:00.000Z",
    linkedEmployees: "1",
    payProfile: "Bi-Monthly (W2)",
    payFrequency: "Semi Monthly",
    unpaidEmpoyees: "1",
    totalPayout: "0.00",
    lastUpdate: "2025-04-14T00:00:00.000Z",
  },
  {
    payDay: "2025-04-14T00:00:00.000Z",
    payPeriod: "2025-03-16T00:00:00.000Z TO 2025-03-31T00:00:00.000Z",
    linkedEmployees: "57",
    payProfile: "W2 Payroll (Monthly)",
    payFrequency: "Monthly",
    unpaidEmpoyees: "57",
    totalPayout: "-19,473.66",
    lastUpdate: "2025-04-14T00:00:00.000Z",
  },
];


export const openinvoicedata=[
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
 {
  invoiceNumber: "15692",
  employee: "LaTara Leshica Williams",
  client: "Freedom Electronics",
  clientID: "CLN-786",
  invoiceDate: "06/03/2025",
  shippedDate: "06/03/2025",
  invoiceDueDate: "09/01/2025",
  invoicedAmount: "7176.50 USD",
  receivedAmount: "7176.50 USD",
},
]